export const DOMAIN_EXPRESSIONS = [
  /\/\/localhost:/,
  /\/\/console-lab.platforms.nike.com/,
  /\/\/console-dev.platforms.nike.com/,
  /\/\/console-nonprod-stage.platforms.nike.com/,
  /\/\/console-nonprod.platforms.nike.com/,
  /\/\/console-stage.platforms.nike.com/,
  /\/\/console.platforms.nike.com/,
] as const
